import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { lastValueFrom, map } from 'rxjs';
import { SpecificCarrierPriorityShipmentsDTO } from 'src/app/admin-api';
import { IntegrationControllerService } from 'src/app/admin-api/api/integrationController.service';
import { TableColumn } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SpecificCarrierPriorityFormComponent } from './specific-carrier-priority-form/specific-carrier-priority-form.component';

@Component({
  selector: 'app-specific-carrier-priority',
  templateUrl: './specific-carrier-priority.component.html',
  styleUrl: './specific-carrier-priority.component.scss',
  providers: [DialogService, MessageService]
})
export class SpecificCarrierPriorityComponent implements OnInit {
  private integrationService = inject(IntegrationControllerService);
  private title = inject(Title);
  private dialogService = inject(DialogService);
  private messageService = inject(MessageService);

  shipments: SpecificCarrierPriorityShipmentsDTO[];

  cols: Array<TableColumn> = [
    new TableColumn(
      'PersonId',
      'personId',
      true,
      'link',
      '/users/person/',
      'personId'
    ),
    new TableColumn('Assinante', 'personName', true, 'text'),
    new TableColumn('CPF', 'personCpf', true, 'number'),
    new TableColumn('E-mail', 'personEmail', true, 'text'),
    new TableColumn('Transportadora', 'shippingCompanyName', true, 'text'),
    new TableColumn(
      'Transportadora Ativa',
      'isShippingCompanyActive',
      true,
      'text'
    ),
    new TableColumn('Motivo', 'reason', true, 'text'),
    new TableColumn('Responsável', 'responsible', true, 'text'),
    new TableColumn('Estado', 'addressState', true, 'text'),
    new TableColumn('Cidade', 'addressCity', true, 'text'),
    new TableColumn('Bairro', 'addressNeighborhood', true, 'text'),
    new TableColumn('CEP', 'addressPostalCode', true, 'text'),
    new TableColumn('Endereço', 'addressStreet', true, 'text'),
    new TableColumn('Data de cadastro', 'dateCreated', true, 'date'),
    new TableColumn('Data de atualização', 'dateUpdated', true, 'date')
  ];

  ngOnInit(): void {
    this.title.setTitle('Integrações - Envios com Transportadora Prioritária');
    this.fetchShipments();
  }

  async fetchShipments(): Promise<void> {
    try {
      LoaderService.showLoader();
      this.shipments = await lastValueFrom(
        this.integrationService.listAll().pipe(map((data) => data.result))
      );
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  openCreateDialog(): void {
    this.dialogService
      .open(SpecificCarrierPriorityFormComponent, {
        header: 'Cadastrar Transportadora Prioritária',
        width: '700px',
        modal: true,
        maximizable: true
      })
      .onClose.subscribe(async (data) => {
        if (data) {
          LoaderService.showLoader();
          await this.fetchShipments();
          this.messageService.add({
            summary: 'Sucesso',
            detail: 'Transportadora prioritária cadastrada com sucesso!',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        }
      });
  }
}
